"use client"

import { motion } from "framer-motion"
import { Check, X } from "lucide-react"

export default function WhyUseTrendhopper() {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  }

  return (
    <section className="relative w-full overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-slate-900" />

      <div className="relative w-full max-w-6xl mx-auto px-4 py-24">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-6xl font-bold text-center text-white mb-16"
        >
          Why use{" "}
          <span className="bg-gradient-to-r from-orange-500 via-red-500 to-rose-500 bg-clip-text text-transparent">
            Trendhopper?
          </span>
        </motion.h1>

        <motion.div variants={container} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-8">
          {/* Manual Process Card */}
          <div className="rounded-lg border border-slate-800 bg-slate-900/40 backdrop-blur-sm transition-colors hover:bg-slate-900/60">
            <div className="p-6">
              <h2 className="text-2xl font-semibold text-white mb-6">Manual Process</h2>
              <motion.ul variants={container} className="space-y-4">
                {[
                  "Research topics and brainstorm blog ideas",
                  "Write and edit content from scratch",
                  "Optimize for SEO, including finding keywords",
                  "Format and publish the post manually",
                ].map((text, i) => (
                  <motion.li key={i} variants={item} className="flex items-start gap-3">
                    <div className="mt-1">
                      <X className="h-5 w-5 text-red-500" />
                    </div>
                    <span className="text-slate-300 text-lg">{text}</span>
                  </motion.li>
                ))}
              </motion.ul>

              <div className="pt-10 flex items-center gap-3">
                <span className="font-medium text-white">Total:</span>
                <span className="bg-red-500/90 backdrop-blur-sm text-white px-4 py-1.5 rounded-full font-medium">
                  5-8 hours per post
                </span>
              </div>
            </div>
          </div>

          {/* Trendhopper Process Card */}
          <div className="rounded-lg border border-slate-700 bg-slate-800/40 backdrop-blur-sm transition-colors hover:bg-slate-800/60">
            <div className="p-6">
              <h2 className="text-2xl font-semibold text-white mb-6">Automated with Trendhopper</h2>
              <motion.ul variants={container} className="space-y-4">
                {[
                  "Automatically generate blog topics and outlines",
                  "Create high-quality, ready-to-publish content",
                  "Optimize posts for SEO with keywords and meta descriptions",
                  "Instantly format and prepare for publishing",
                ].map((text, i) => (
                  <motion.li key={i} variants={item} className="flex items-start gap-3">
                    <div className="mt-1">
                      <Check className="h-5 w-5 text-emerald-500" />
                    </div>
                    <span className="text-slate-300 text-lg">{text}</span>
                  </motion.li>
                ))}
              </motion.ul>

              <div className="pt-10 flex items-center gap-3">
                <span className="font-medium text-white">Total:</span>
                <span className="bg-emerald-500/90 backdrop-blur-sm text-white px-4 py-1.5 rounded-full font-medium">
                  5 minutes
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

